import * as React from "react";
import { Link, Navigate } from "react-router-dom";
import { Box, useMediaQuery } from "@mui/material";
import montage from "../videos/WTC Artist Montage v2.mp4";
import { CenterTile } from "../components/CenterTile";
import { SponsorTile } from  "../components/SponsorTile";
import { useEffect } from "react";

function ScreenSaver() {
    const galleryDevice = useMediaQuery('(min-width:3000px)');
    // const contrastContext = useContext(ContrastContext);

    useEffect(() => {
        window.gtag('event', 'page_view', {
                page_title: 'We The Culture',
                page_location: 'https://apps.discovernewfields.org/we-the-culture',
                gallery_device: galleryDevice,
                send_to: 'G-PC1LP4S0D0'
        });
    }, [galleryDevice])

    const mobileDevice = useMediaQuery('(max-width:1000px)'); 

    // function toggleContrast() {
    //     contrastContext.setHighContrast(!contrastContext.highContrast);
    // }
    return (
        // Skip the Screen Saver for mobile devices
        mobileDevice ? <Navigate to = "/artists"/> :
        <Box role="main" aria-label="We The Culture Splash Page">
            <Link to="/artists" state="from home" aria-label="Links to the artists navigation page">
                <Box
                    sx={{
                        height: "100vh",
                        minHeight: "100vh",
                        position: "relative", //A positioned parent element as a reference for the absolutely positioned children
                    }}
                >
                    <Box
                        sx={{
                            height: "100%",
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center"
                        }}
                    >
                        <video autoPlay loop muted width={"100%"} aria-label="Artist montage video in background ... no audio">
                            <source src={montage} type="video/mp4" />
                        </video>
                    </Box>
                    <CenterTile
                        text1 = {`${galleryDevice ? 'Touch' : 'Click'} the screen to begin`}
                        animateText={false}
                        role="banner"
                        aria-label="Center title card"
                    />
                    <SponsorTile role="region" aria-label="Ice Miller sponsor tile"/>
                </Box>
            </Link>
        </Box>
    );
}

export default ScreenSaver;
